import { ChatWidgetTurn } from "@/types";

/** Merge newly polled turns into existing history, de-duping by id and keeping
 * chronological order. Operator (`agent`) turns render on the left via
 * `convertApiTurnsToUITurns`. */
export function mergeTurns(
  prev: ChatWidgetTurn[],
  incoming: ChatWidgetTurn[],
): ChatWidgetTurn[] {
  const seen = new Set(prev.map((turn) => turn.id));
  const additions = incoming.filter((turn) => !seen.has(turn.id));
  if (additions.length === 0) {
    return prev;
  }
  return [...prev, ...additions].sort(
    (a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
  );
}

/** Return the ISO timestamp of the most recent turn, used as the poll `after`
 * cursor so each poll only fetches turns newer than what we already have. */
export function latestTimestamp(turns: ChatWidgetTurn[]): string | undefined {
  let maxMs = -Infinity;
  let maxIso: string | undefined;
  turns.forEach((turn) => {
    const ms = new Date(turn.timestamp).getTime();
    if (!Number.isNaN(ms) && ms > maxMs) {
      maxMs = ms;
      maxIso = turn.timestamp;
    }
  });
  return maxIso;
}
